export default "__VITE_ASSET__f87405ba__"